import { useEffect, useState } from "react";
import { ChevronDown, Trash2, Users } from "lucide-react";
import { FileList } from "@/components/apps/FileList";
import { UnitAccess } from "@/components/bundles/UnitAccess";

// The newest ready, visible package of each type is what apps get, so it carries the "Latest" badge here. Returns go to base, so they never do.
const markCurrent = (packages) => {
  const current = new Set();
  const seen = new Set();
  packages.forEach((p) => {
    const t = p.package_type || "other";
    if (t === "return" || seen.has(t) || p.status !== "ready" || p.hidden || p.missing) return;
    seen.add(t);
    current.add(p.id);
  });
  return packages.map((p) => ({ ...p, latest: current.has(p.id) }));
};

export const UnitCard = ({ app, unit, packages, isAdmin, actions, onDeleteUnit, onChanged }) => {
  const [open, setOpen] = useState(Boolean(unit.code));
  const [confirm, setConfirm] = useState(false);
  useEffect(() => {
    if (!confirm) return undefined;
    const t = setTimeout(() => setConfirm(false), 3000);
    return () => clearTimeout(t);
  }, [confirm]);
  const list = markCurrent(packages);

  return (
    <section className="rounded-[28px] border border-sky-100 bg-white p-5 sm:p-7" data-testid={`unit-card-${unit.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-sky-50 text-sky-700"><Users className="h-5 w-5" /></span>
          <div>
            <h3 className="font-display text-xl font-semibold text-ink" data-testid={`unit-name-${unit.id}`}>{unit.name}</h3>
            <p className="text-xs text-slate-600" data-testid={`unit-count-${unit.id}`}>{packages.length} version{packages.length === 1 ? "" : "s"}{isAdmin ? ` · ${unit.active ? "app active" : unit.code_pending ? "waiting for activation" : "no app access"}` : ""}</p>
          </div>
        </div>
        {isAdmin && (
          <div className="flex items-center gap-2">
            <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} className="inline-flex items-center gap-1 rounded-full border border-slate-200 px-4 py-2 text-xs font-medium text-ink hover:border-sky-600 hover:text-sky-700" data-testid={`unit-access-toggle-${unit.id}`}>
              App access<ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
            </button>
            <button type="button" onClick={() => (confirm ? onDeleteUnit(unit) : setConfirm(true))} title="Remove unit (only when it has no packages)"
              className={`inline-flex items-center gap-1 rounded-full px-3 py-2 text-xs transition-colors ${confirm ? "bg-red-600 text-white" : "text-slate-500 hover:bg-red-50 hover:text-red-600"}`} data-testid={`unit-delete-${unit.id}`}>
              <Trash2 className="h-3.5 w-3.5" />{confirm ? "Remove unit?" : ""}
            </button>
          </div>
        )}
      </div>
      {isAdmin && open && <UnitAccess appId={app.id} unit={unit} onChanged={onChanged} />}
      <div className="mt-5">
        <FileList files={list} isAdmin={isAdmin} latestToggle={false} onFlag={actions.flag} onNotify={actions.notify} onDelete={actions.remove} onStop={actions.stop} onMove={() => {}}
          emptyText={`No packages for ${unit.name} yet.`} />
      </div>
    </section>
  );
};
